module.exports = __webpack_public_path__ + "img/check-circle.45b5c4f3.svg";